import {
  getSingleCollectionFinderOptions,
  getCollectionFieldTraitOptions,
  getCollectionOptionsForSelect,
  getFieldOptionsForAddToRemoveFromSelect,
  getFieldOptionsForCollectionSelect,
  getFieldOptionsForSelect,
  getInstalledPlugins,
} from '../pluginComponentApi';

export default async function (editor, opts = {}) {
  const {
    collections,
    projectId,
    version,
    bindCollectionOptions,
    traits,
    snippetCollectionTraitOptions,
  } = opts;
  const traitManager = editor.TraitManager;
  let { collection, session, sessionTenant, sessionUserSettings, sessionSubTenant } =
    bindCollectionOptions;
  const plugins = projectId ? await getInstalledPlugins(projectId, version) : '';
  const tenantPlugin = plugins && plugins.find((plugin) => plugin.code === 'MULTI_TENANT_SAAS');
  const hasMultiTenantPlugin = !!tenantPlugin;

  if (!collection) {
    collection = snippetCollectionTraitOptions.collection;
  }
  const dataSessionSeries = `data-session-series`;
  const dataSessionLabel = `data-session-label`;
  const dataSessionTenantSeries = `data-session-tenant-series`;
  const dataSessionTenantLabel = `data-session-tenant-label`;
  const dataSessionUserSettingsSeries = `data-session-user-settings-series`;
  const dataSessionUserSettingsLabel = `data-session-user-settings-label`;
  const dataSessionSubTenantSeries = `data-session-sub-tenant-series`;
  const dataSessionSubTenantLabel = `data-session-sub-tenant-label`;
  const dataCollectionSeries = collection ? `data-${collection.collectionId}-series` : '';
  const dataCollectionLabel = collection ? `data-${collection.collectionId}-label` : '';
  const dataFilter = `data-filter-id`;
  const dataFilterCollection = `data-filter-collection`;
  const dataFilterSeries = 'data-filter-series';
  const dataFilterLabel = 'data-filter-label';

  let componentContent = '';

  traitManager.addType(traits.circularGaugeChart.type, {
    createInput({ trait }) {
      componentContent = trait.attributes.content;
      const customLabel = 'Get Value From';
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
        <div class="gjs-container">
          <div class="gjs-row">
            <div class="gjs-label-wrp">
              <div class="gjs-label" title="Get Content">Get Content</div>
            </div>
            <div id="select-getTextFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getTextFrom">
              <div class="gjs-field">
                <select class="select-getTextFrom form-control form-control-sm options-light">
                  <option value="" selected>- Get Content -</option>
                  ${
                    collection &&
                    `<option value="collection">${customLabel} ${collection.collectionTitle}</option>`
                  }
                  ${
                    session &&
                    `
                    <option value="session">${customLabel} Logged In User</option>
                  `
                  }
                  ${
                    session &&
                    hasMultiTenantPlugin &&
                    `
                    <option value="sessionTenant">${customLabel} Logged In ${sessionTenant.collectionTitle}</option>
                  `
                  }
                  ${
                    sessionUserSettings &&
                    hasMultiTenantPlugin &&
                    `
                    <option value="sessionUserSettings">${customLabel} Logged In ${sessionUserSettings.collectionTitle}</option>
                  `
                  }
                  ${
                    sessionSubTenant &&
                    hasMultiTenantPlugin &&
                    `
                    <option value="sessionSubTenant">${customLabel} Logged In ${sessionSubTenant.collectionTitle}</option>
                  `
                  }
                  <option value="filter">${customLabel} Collection Filters</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div id="get-browser-key" class="gjs-container" style="display: none;">
          <div class="gjs-row">
            <div id="entityCollection-label-div" class="gjs-label-wrp">
              <div class="gjs-label" title="Collection Name">Collection Name</div>
            </div>
            <div id="browserStorageKeyDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
              <div class="gjs-field">
                <select class="browserStorageKey form-control form-control-sm options-light"> </select>
              </div>
            </div>
          </div>
          <div class="gjs-row">
            <div id="entityField-label-div" class="gjs-label-wrp">
              <div class="gjs-label" title="Field Name">Field Name</div>
            </div>
            <div id="browserStorageFieldDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
              <div class="gjs-field">
                <select class="browserStorageFieldKey form-control form-control-sm options-light"> </select>
              </div>
            </div>
          </div>
        </div>

        <div id="get-content-field-container" class="gjs-container" style="display: none;">
          <div class="gjs-row">
            <div id="collection-label-div" class="gjs-label-wrp" style="display: none;">
              <div class="gjs-label" title="Collection Name">Collection Name</div>
            </div>
            <div id="select-collection-div" class="gjs-field-wrp gjs-field-wrp--collection-field-div" style="display: none;">
              <div class="gjs-field gjs-field--select-collection-div">
                <select class="selectCollection form-control form-control-sm options-light"> </select>
              </div>
            </div>
            <div id="filter-label-div" class="gjs-label-wrp" style="display: none;">
              <div class="gjs-label" title="Collection Filter">Collection Filter</div>
            </div>
            <div id="select-filter-div" class="gjs-field-wrp gjs-field-wrp--select-filter-div" style="display: none;">
              <div class="gjs-field">
                <select class="select-filter form-control form-control-sm options-light"> </select>
              </div>
            </div>
          </div>
          <div class="gjs-row">
            <div id="data-series" class="gjs-label-wrp">
              <div class="gjs-label" title="Series Field">Series Data</div>
            </div>
            <div id="select-data-series-div" class="gjs-field-wrp gjs-field-wrp--select-data-series-div" style="display: none;">
              <div class="gjs-field gjs-field--select-data-series-div">
                <select class="selectDataSeries form-control form-control-sm options-light"> </select>
              </div>
            </div>
          </div>
          <div class="gjs-row">
            <div id="data-labels" class="gjs-label-wrp">
              <div class="gjs-label" title="Labels Field">Labels Data</div>
            </div>
            <div id="select-data-labels-div" class="gjs-field-wrp gjs-field-wrp--select-data-labels-div" style="display: none;">
              <div class="gjs-field gjs-field--select-data-labels-div">
                <select class="selectDataLabels form-control form-control-sm options-light"> </select>
              </div>
            </div>
          </div>
      </div>
  `;
      const selectGetTextFrom = el.querySelector('.select-getTextFrom');
      const getContentFieldContainer = el.querySelector('#get-content-field-container');
      // For Browser
      // const getBrowserKey = el.querySelector('#get-browser-key');
      // const browserStorageKeyDiv = el.querySelector('#browserStorageKeyDiv');
      // const browserStorageKey = el.querySelector('.browserStorageKey');
      // const browserStorageFieldDiv = el.querySelector('#browserStorageFieldDiv');
      // const browserStorageFieldKey = el.querySelector('.browserStorageFieldKey');
      // For Data Series
      const dataSeries = el.querySelector('#data-series');
      const selectDataSeriesDiv = el.querySelector('#select-data-series-div');
      const selectDataSeries = el.querySelector('.selectDataSeries');

      // For Data Labels
      const dataLabels = el.querySelector('#data-labels');
      const selectDataLabelsDiv = el.querySelector('#select-data-labels-div');
      const selectDataLabels = el.querySelector('.selectDataLabels');

      // For Collection
      const dataCollection = el.querySelector('#collection-label-div');
      const selectCollectionDiv = el.querySelector('#select-collection-div');
      const selectCollection = el.querySelector('.selectCollection');

      // For Filter
      const filterLabelDiv = el.querySelector('#filter-label-div');
      const selectFilterDiv = el.querySelector('#select-filter-div');
      const selectFilter = el.querySelector('.select-filter');

      if (selectGetTextFrom) {
        selectGetTextFrom.addEventListener('change', async (ev) => {
          selectDataSeries.innerHTML = '';
          selectDataLabels.innerHTML = '';
          selectCollection.innerHTML = '';
          const getTextFromValue = selectGetTextFrom.value;
          let optionHtml = `<option value="" selected>None</option>`;

          if (getTextFromValue) {
            getContentFieldContainer.style.display = 'block';
            // For Browser
            // if (getTextFromValue === 'browserStorage') {
            //   getBrowserKey.style.display = 'block';
            // } else {
            //   getBrowserKey.style.display = 'none';
            // }
          } else {
            getContentFieldContainer.style.display = 'none';
          }
          if (
            [
              'session',
              'sessionTenant',
              'collection',
              'sessionUserSettings',
              'sessionSubTenant',
            ].includes(getTextFromValue)
          ) {
            let fieldOptions = [];
            if (session && session.options && getTextFromValue === 'session') {
              fieldOptions = session.options;
            }
            if (sessionTenant && sessionTenant.options && getTextFromValue === 'sessionTenant') {
              fieldOptions = sessionTenant.options;
            }
            if (
              sessionUserSettings &&
              sessionUserSettings.options &&
              getTextFromValue === 'sessionUserSettings'
            ) {
              fieldOptions = sessionUserSettings.options;
            }
            if (
              sessionSubTenant &&
              sessionSubTenant.options &&
              getTextFromValue === 'sessionSubTenant'
            ) {
              fieldOptions = sessionSubTenant.options;
            }
            if (collection && collection.options && getTextFromValue === 'collection') {
              fieldOptions = collection.options;
            }
            optionHtml = session ? getFieldOptionsForSelect(fieldOptions) : '';

            dataLabels.style.display = 'block';
            dataSeries.style.display = 'block';
            selectDataSeriesDiv.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            selectDataSeries.innerHTML = optionHtml;
            selectDataLabels.innerHTML = optionHtml;

            selectCollectionDiv.style.display = 'none';
            dataCollection.style.display = 'none';
            selectFilterDiv.style.display = 'none';
            filterLabelDiv.style.display = 'none';
          }
          // For Browser
          // else if (
          //   ['previousActionResponse', 'previousActionFormData'].includes(selectGetTextFrom.value)
          // ) {
          //   selectDataSeriesDiv.style.display = 'none';
          //   selectDataLabelsDiv.style.display = 'none';
          // } else if (selectGetTextFrom.value === 'browserStorage') {
          //   browserStorageKey.innerHTML = collections
          //     ? getCollectionOptionsForSelect(collections)
          //     : '';
          //   browserStorageFieldKey.innerHTML = `<option value="" selected>None</option>`;
          //   browserStorageFieldDiv.style.display = 'block';
          //   browserStorageKeyDiv.style.display = 'block';
          //   selectDataSeriesDiv.style.display = 'none';
          //   selectDataLabelsDiv.style.display = 'none';
          // }
          else if (selectGetTextFrom.value === 'filter') {
            optionHtml = collections ? getCollectionOptionsForSelect(collections) : '';
            selectCollection.innerHTML = optionHtml;
            selectFilter.innerHTML = `<option value="" selected>None</option>`;
            selectCollectionDiv.style.display = 'block';
            dataCollection.style.display = 'block';
            selectFilterDiv.style.display = 'block';
            filterLabelDiv.style.display = 'block';

            selectDataSeriesDiv.style.display = 'block';
            dataSeries.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            dataLabels.style.display = 'block';
          } else {
            selectDataSeriesDiv.style.display = 'none';
            selectDataLabelsDiv.style.display = 'none';
            filterLabelDiv.style.display = 'none';
            selectFilterDiv.style.display = 'none';
            getContentFieldContainer.style.display = 'none';
            // getBrowserKey.style.display = 'none';
          }
          // browserStorageKey.value = '';
        });
      }

      selectCollection.addEventListener('change', async (ev) => {
        if (selectGetTextFrom && selectGetTextFrom.value === 'filter') {
          // const selectedCollection = collections.find(
          //   (col) => col.collectionName === ev.target.value,
          // );
          const filterdCollections = collections.filter(
            (col) => col.collectionName === ev.target.value,
          );
          const selectedCollection = filterdCollections[0];
          selectFilter.innerHTML = getSingleCollectionFinderOptions(selectedCollection);
          const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
          const fieldOptions = getFieldOptionsForSelect(fields);
          selectDataSeries.innerHTML = fieldOptions;
          selectDataLabels.innerHTML = fieldOptions;
        }
      });

      // browserStorageKey.addEventListener('change', async (ev) => {
      //   const selectedCollection = collections.find(
      //     (col) => col.collectionName === ev.target.value,
      //   );
      //   const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
      //   browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
      // });
      return el;
    },
    onEvent({ elInput, component }) {
      const selectGetTextFrom = document.querySelector('.select-getTextFrom');
      const selectGetTextFromValue = selectGetTextFrom ? selectGetTextFrom.value : '';

      const selectDataSeries = elInput.querySelector('.selectDataSeries');
      const selectDataSeriesDiv = elInput.querySelector('#select-data-series-div');
      let selectDataSeriesValue = selectDataSeries ? selectDataSeries.value : '';

      const selectedDataSeries = selectDataSeries
        ? selectDataSeries.options[selectDataSeries.selectedIndex]
        : null;

      const dataSeriesType = selectedDataSeries ? selectedDataSeries.getAttribute('type') : 'text';

      if (selectDataSeriesValue.includes("'")) {
        selectDataSeriesValue = selectDataSeriesValue.split("'").join('"');
      }

      const selectDataLabels = elInput.querySelector('.selectDataLabels');
      const selectDataLabelsDiv = elInput.querySelector('#select-data-labels-div');
      let selectDataLabelsValue = selectDataLabels ? selectDataLabels.value : '';
      const selectedDataLabels = selectDataLabels
        ? selectDataLabels.options[selectDataLabels.selectedIndex]
        : null;
      const dataLabelsType = selectedDataLabels ? selectedDataLabels.getAttribute('type') : 'text';
      if (selectDataLabelsValue.includes("'")) {
        selectDataLabelsValue = selectDataLabelsValue.split("'").join('"');
      }

      const selectFilter = elInput.querySelector('.select-filter');
      const selectFilterValue = selectFilter.value || '';

      // const browserStorageKey = elInput.querySelector('.browserStorageKey');
      // const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
      // let browserStorageKeyValue = browserStorageKey.value || '';
      // let browserStorageFieldKeyValue = browserStorageFieldKey.value || '';

      const selectCollection = elInput.querySelector('.selectCollection');
      const selectCollectionValue = selectCollection.value || '';
      console.log(
        '%c selectCollectionValue test',
        'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
        selectCollectionValue,
      );
      console.log(
        '%c selectGetTextFromValue test',
        'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
        selectGetTextFromValue,
      );
      if (selectGetTextFromValue) {
        component.set('getContentFrom', selectGetTextFromValue);
        let attr = component.getAttributes();
        const id = attr.id;
        attr = {};
        attr.id = id;
        component.setAttributes(attr);
        console.log('selectDataSeriesValue test', selectDataSeriesValue);
        console.log('selectDataLabelsValue test', selectDataLabelsValue);
        if (selectGetTextFromValue === 'collection') {
          if (selectDataSeriesValue) {
            component.addAttributes({ [dataCollectionSeries]: selectDataSeriesValue });
          }
          if (selectDataLabelsValue) {
            component.addAttributes({ [dataCollectionLabel]: selectDataLabelsValue });
          }
          //Delete Attribute
          delete attr[dataFilter];
          delete attr[dataFilterCollection];
          delete attr[dataSessionTenantSeries];
          delete attr[dataSessionUserSettingsSeries];
          delete attr[dataSessionUserSettingsLabel];
          delete attr[dataSessionTenantLabel];
          delete attr[dataSessionSubTenantSeries];
          delete attr[dataSessionSubTenantLabel];
          delete attr[dataSessionSeries];
          delete attr[dataSessionLabel];
        } else if (selectGetTextFromValue === 'session') {
          if (selectDataSeriesValue) {
            component.addAttributes({ [dataSessionSeries]: selectDataSeriesValue });
          }
          if (selectDataLabelsValue) {
            component.addAttributes({ [dataSessionLabel]: selectDataLabelsValue });
          }
          //Delete Attribute
          delete attr[dataFilter];
          delete attr[dataFilterCollection];
          delete attr[dataSessionTenantSeries];
          delete attr[dataSessionUserSettingsSeries];
          delete attr[dataSessionUserSettingsLabel];
          delete attr[dataSessionTenantLabel];
          delete attr[dataSessionSubTenantSeries];
          delete attr[dataSessionSubTenantLabel];
          delete attr[dataCollectionSeries];
          delete attr[dataCollectionLabel];
        } else if (selectGetTextFromValue === 'sessionTenant') {
          if (selectDataSeriesValue) {
            component.addAttributes({ [dataSessionTenantSeries]: selectDataSeriesValue });
          }
          if (selectDataLabelsValue) {
            component.addAttributes({ [dataSessionTenantLabel]: selectDataLabelsValue });
          }
          //Delete Attribute
          delete attr[dataFilter];
          delete attr[dataFilterCollection];
          delete attr[dataSessionUserSettingsSeries];
          delete attr[dataSessionUserSettingsLabel];
          delete attr[dataSessionSubTenantSeries];
          delete attr[dataSessionSubTenantLabel];
          delete attr[dataSessionSeries];
          delete attr[dataSessionLabel];
          delete attr[dataCollectionSeries];
          delete attr[dataCollectionLabel];
        } else if (selectGetTextFromValue === 'sessionUserSettings') {
          if (selectDataSeriesValue) {
            component.addAttributes({ [dataSessionUserSettingsSeries]: selectDataSeriesValue });
          }
          if (selectDataLabelsValue) {
            component.addAttributes({ [dataSessionUserSettingsLabel]: selectDataLabelsValue });
          }
          //Delete Attribute
          delete attr[dataFilter];
          delete attr[dataFilterCollection];
          delete attr[dataSessionTenantSeries];
          delete attr[dataSessionTenantLabel];
          delete attr[dataSessionSubTenantSeries];
          delete attr[dataSessionSubTenantLabel];
          delete attr[dataSessionSeries];
          delete attr[dataSessionLabel];
          delete attr[dataCollectionSeries];
          delete attr[dataCollectionLabel];
        } else if (selectGetTextFromValue === 'sessionSubTenant') {
          if (selectDataSeriesValue) {
            component.addAttributes({ [dataSessionSubTenantSeries]: selectDataSeriesValue });
          }
          if (selectDataLabelsValue) {
            component.addAttributes({ [dataSessionSubTenantLabel]: selectDataLabelsValue });
          }
          //Delete Attribute
          delete attr[dataFilter];
          delete attr[dataFilterCollection];
          delete attr[dataSessionTenantSeries];
          delete attr[dataSessionTenantLabel];
          delete attr[dataSessionUserSettingsSeries];
          delete attr[dataSessionUserSettingsLabel];
          delete attr[dataSessionSeries];
          delete attr[dataSessionLabel];
          delete attr[dataCollectionSeries];
          delete attr[dataCollectionLabel];
        } else if (selectGetTextFromValue === 'filter') {
          component.addAttributes({
            [dataFilter]: selectFilterValue,
            [dataFilterCollection]: selectCollectionValue,
          });
          if (selectDataSeriesValue) {
            component.addAttributes({ [dataFilterSeries]: selectDataSeriesValue });
          }
          if (selectDataLabelsValue) {
            component.addAttributes({ [dataFilterLabel]: selectDataLabelsValue });
          }
          delete attr[dataSessionTenantSeries];
          delete attr[dataSessionTenantLabel];
          delete attr[dataSessionUserSettingsSeries];
          delete attr[dataSessionUserSettingsLabel];
          delete attr[dataSessionSubTenantSeries];
          delete attr[dataSessionSubTenantLabel];
          delete attr[dataSessionSeries];
          delete attr[dataSessionLabel];
          delete attr[dataCollectionSeries];
          delete attr[dataCollectionLabel];
        }

        // if (selectDataSeriesValue) {
        //   if (selectGetTextFromValue === 'session') {
        //     component.addAttributes({ [dataSessionFieldName]: selectDataSeriesValue });
        //     component.set('content', '');
        //     component.set(
        //       'content',
        //       selectDataSeries.options[selectDataSeries.selectedIndex].text,
        //     );
        //   } else if (selectGetTextFromValue === 'sessionTenant') {
        //     component.addAttributes({ [dataSessionTenantFieldName]: selectDataSeriesValue });
        //     component.set('content', '');
        //     component.set(
        //       'content',
        //       selectDataSeries.options[selectDataSeries.selectedIndex].text,
        //     );
        //   } else if (selectGetTextFromValue === 'collection') {
        //     component.addAttributes({
        //       [dataCollectionFieldName]: selectDataSeriesValue,
        //       'data-field-type': fieldType,
        //     });
        //     component.set('content', '');
        //     component.set(
        //       'content',
        //       selectDataSeries.options[selectDataSeries.selectedIndex].text,
        //     );
        //   } else if (selectGetTextFromValue === 'filter' && selectFilterValue) {
        //     component.addAttributes({
        //       [dataFilter]: selectFilterValue,
        //       [dataFilterCollection]: selectDataSeriesValue,
        //     });
        //     component.set('content', selectFilter.options[selectFilter.selectedIndex].text);
        //   }
        // }

        // if (selectGetTextFromValue === 'previousActionResponse') {
        //   delete attr[dataCollectionFieldName];
        //   delete attr[dataFilter];
        //   delete attr[dataFilterCollection];
        //   delete attr['data-previous-action-formdata'];
        //   delete attr['data-browser-storage'];
        //   component.set('content', 'Session content');
        //   component.setAttributes(attr);
        //   selectDataSeriesDiv.style.display = 'none';
        // } else if (selectGetTextFromValue === 'previousActionFormData') {
        //   delete attr[dataCollectionFieldName];
        //   delete attr[dataFilter];
        //   delete attr[dataFilterCollection];
        //   delete attr['data-previous-action-response'];
        //   delete attr['data-browser-storage'];
        //   component.set('content', 'Session form content');
        //   component.setAttributes(attr);
        //   selectDataSeriesDiv.style.display = 'none';
        // } else if (selectGetTextFromValue === 'browserStorage') {
        //   attr['data-browser-storage'] = browserStorageFieldKeyValue
        //     ? browserStorageFieldKeyValue
        //     : attr.name;
        //   attr['data-storage-key'] = browserStorageKeyValue
        //     ? `entity_${browserStorageKeyValue}`
        //     : attr.name;
        //   delete attr[dataCollectionFieldName];
        //   delete attr[dataFilter];
        //   delete attr[dataFilterCollection];
        //   delete attr['data-previous-action-formdata'];
        //   delete attr['data-previous-action-response'];
        //   component.set('content', 'Collection (Browser Storage)');
        //   component.setAttributes(attr);
        //   selectDataSeriesDiv.style.display = 'none';
        // }
      } else {
        const attr = component.getAttributes();
        delete attr[dataSessionFieldName];
        delete attr[dataSessionTenantFieldName];
        delete attr[dataCollectionFieldName];
        delete attr['data-field-type'];
        delete attr[dataFilter];
        delete attr[dataFilterCollection];
        delete attr['data-previous-action-response'];
        delete attr['data-previous-action-formdata'];
        delete attr['data-browser-storage'];
        delete attr['data-storage-key'];
        component.setAttributes(attr);
        component.set('getContentFrom', '');
        component.set('content', componentContent);
      }
    },
    async onUpdate({ elInput, component }) {
      const attr = component.getAttributes();
      //Removes empty attribute key
      delete attr[''];
      const getContentFrom = component.get('getContentFrom');
      const selectGetTextFrom = elInput.querySelector('.select-getTextFrom');

      const selectFilterDiv = elInput.querySelector('#select-filter-div');
      const selectFilter = elInput.querySelector('.select-filter');
      const filterLabelDiv = elInput.querySelector('#filter-label-div');

      const selectCollectionDiv = elInput.querySelector('#select-collection-div');
      const selectCollection = elInput.querySelector('.selectCollection');
      const collectionLabelDiv = elInput.querySelector('#collection-label-div');

      const selectDataSeriesDiv = elInput.querySelector('#select-data-series-div');
      const selectDataSeries = elInput.querySelector('.selectDataSeries');

      const selectDataLabelsDiv = elInput.querySelector('#select-data-labels-div');
      const selectDataLabels = elInput.querySelector('.selectDataLabels');

      const getContentFieldContainer = elInput.querySelector('#get-content-field-container');

      // const getBrowserKey = elInput.querySelector('#get-browser-key');
      // const browserStorageKeyDiv = elInput.querySelector('#browserStorageKeyDiv');
      // const browserStorageKey = elInput.querySelector('.browserStorageKey');
      // const browserStorageFieldDiv = elInput.querySelector('#browserStorageFieldDiv');
      // const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');

      // let previousActionFormDataValue = attr['data-previous-action-formdata'] || '';
      // let previousActionResponseFieldValue = attr['data-previous-action-response'] || '';
      // let entityStorageValue = attr['data-browser-storage'] || '';
      // let storageKeyValue = attr['data-storage-key'] || '';
      // let browserStorageKeyValue = '';
      // let browserStorageFieldKeyValue = '';

      if (selectGetTextFrom) {
        selectGetTextFrom.value = getContentFrom || '';
      }

      // if (
      //   previousActionFormDataValue ||
      //   previousActionResponseFieldValue ||
      //   entityStorageValue ||
      //   storageKeyValue
      // ) {
      //   if (entityStorageValue || storageKeyValue) {
      //     browserStorageKeyValue = storageKeyValue.replace('entity_', '');
      //     browserStorageFieldKeyValue = entityStorageValue;
      //   }
      // }

      const collectionSeriesValue = attr[dataCollectionSeries] || '';
      console.log('collectionSeriesValue onUpdate test', collectionSeriesValue);
      const collectionLabelValue = attr[dataCollectionLabel] || '';
      console.log('dataCollectionLabel onUpdate test', dataCollectionLabel);

      const sessionSeriesValue = attr[dataSessionSeries] || '';
      console.log('sessionSeriesValue onUpdate test', sessionSeriesValue);
      const sessionLabelValue = attr[dataSessionLabel] || '';
      console.log('sessionLabelValue onUpdate test', sessionLabelValue);

      const sessionTenantSeriesValue = attr[dataSessionTenantSeries] || '';
      console.log('sessionTenantSeriesValue onUpdate test', sessionTenantSeriesValue);
      const sessionTenantLabelValue = attr[dataSessionTenantLabel] || '';
      console.log('sessionTenantLabelValue onUpdate test', sessionTenantLabelValue);

      const sessionUserSettingsSeriesValue = attr[dataSessionUserSettingsSeries] || '';
      console.log('sessionUserSettingsSeriesValue onUpdate test', sessionUserSettingsSeriesValue);
      const sessionUserSettingsLabelValue = attr[dataSessionUserSettingsLabel] || '';
      console.log('sessionUserSettingsLabelValue onUpdate test', sessionUserSettingsLabelValue);

      const sessionSubTenantSeriesValue = attr[dataSessionSubTenantSeries] || '';
      const sessionSubTenantLabelValue = attr[dataSessionSubTenantLabel] || '';

      const filterSeriesValue = attr[dataFilterSeries] || '';
      console.log('filterSeriesValue onUpdate test', filterSeriesValue);
      const filterLabelValue = attr[dataFilterLabel] || '';
      console.log('filterLabelValue onUpdate test', filterLabelValue);

      const dataFilterValue = attr[dataFilter] || '';
      console.log('dataFilterValue onUpdate test', dataFilterValue);
      const dataFilterCollectionValue = attr[dataFilterCollection] || '';
      console.log('dataFilterCollectionValue onUpdate test', dataFilterCollectionValue);

      if (getContentFrom) {
        getContentFieldContainer.style.display = 'block';
        let optionHtml = `<option value="" >None</option>`;
        switch (getContentFrom) {
          case 'collection':
            selectDataSeriesDiv.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            optionHtml = collection ? getFieldOptionsForSelect(collection.options) : '';
            selectDataSeries.innerHTML = optionHtml;
            selectDataSeries.value = collectionSeriesValue;
            selectDataLabels.innerHTML = optionHtml;
            selectDataLabels.value = collectionLabelValue;
            break;
          case 'session':
            selectDataSeriesDiv.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            optionHtml = session ? getFieldOptionsForSelect(session.options) : '';
            selectDataSeries.innerHTML = optionHtml;
            selectDataSeries.value = sessionSeriesValue;
            selectDataLabels.innerHTML = optionHtml;
            selectDataLabels.value = sessionLabelValue;
            break;
          case 'sessionTenant':
            selectDataSeriesDiv.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            optionHtml = sessionTenant ? getFieldOptionsForSelect(sessionTenant.options) : '';
            selectDataSeries.innerHTML = optionHtml;
            selectDataSeries.value = sessionTenantSeriesValue;
            selectDataLabels.innerHTML = optionHtml;
            selectDataLabels.value = sessionTenantLabelValue;
            break;
          case 'sessionUserSettings':
            selectDataSeriesDiv.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            optionHtml = sessionUserSettings
              ? getFieldOptionsForSelect(sessionUserSettings.options)
              : '';
            selectDataSeries.innerHTML = optionHtml;
            selectDataSeries.value = sessionUserSettingsSeriesValue;
            selectDataLabels.innerHTML = optionHtml;
            selectDataLabels.value = sessionUserSettingsLabelValue;
            break;
          case 'sessionSubTenant':
            selectDataSeriesDiv.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            optionHtml = sessionSubTenant ? getFieldOptionsForSelect(sessionSubTenant.options) : '';
            selectDataSeries.innerHTML = optionHtml;
            selectDataSeries.value = sessionSubTenantSeriesValue;
            selectDataLabels.innerHTML = optionHtml;
            selectDataLabels.value = sessionSubTenantLabelValue;
            break;
          case 'filter':
            selectDataSeriesDiv.style.display = 'block';
            selectDataLabelsDiv.style.display = 'block';
            selectFilterDiv.style.display = 'block';
            filterLabelDiv.style.display = 'block';
            selectCollectionDiv.style.display = 'block';
            collectionLabelDiv.style.display = 'block';
            const selectedCollection = dataFilterCollectionValue
              ? collections.find(
                  (collection) => collection.collectionName === dataFilterCollectionValue,
                )
              : '';
            optionHtml = collections ? getCollectionOptionsForSelect(collections) : '';
            selectCollection.innerHTML = optionHtml;
            selectCollection.value = dataFilterCollectionValue;

            selectFilter.innerHTML = getSingleCollectionFinderOptions(selectedCollection);
            selectFilter.value = dataFilterValue;

            const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
            const fieldOptions = getFieldOptionsForSelect(fields);

            selectDataSeries.innerHTML = fieldOptions;
            selectDataSeries.value = filterSeriesValue;
            selectDataLabels.innerHTML = fieldOptions;
            selectDataLabels.value = filterLabelValue;
            break;
          // case 'browserStorage':
          //   getBrowserKey.style.display = 'block';
          //   browserStorageKeyDiv.style.display = 'block';
          //   browserStorageFieldDiv.style.display = 'block';
          //   browserStorageKey.innerHTML = collections
          //     ? getCollectionOptionsForSelect(collections)
          //     : '';
          //   browserStorageKey.value = browserStorageKeyValue;
          //   const entityCollection = collections.find(
          //     (col) => col.collectionName === browserStorageKeyValue,
          //   );
          //   const fields = await getCollectionFieldTraitOptions(entityCollection, collections);
          //   browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
          //   browserStorageFieldKey.value = browserStorageFieldKeyValue;
          //   break;
          default:
            selectDataSeriesDiv.style.display = 'none';
            selectDataLabelsDiv.style.display = 'none';
            selectFilterDiv.style.display = 'none';
            filterLabelDiv.style.display = 'none';
            break;
        }
      } else {
        getContentFieldContainer.style.display = 'none';
        selectDataSeriesDiv.style.display = 'none';
        selectDataLabelsDiv.style.display = 'none';
        selectFilterDiv.style.display = 'none';
      }
    },
  });
}
